import React, { Fragment } from 'react';
import uuid from 'uuid';
import classNames from 'classnames';
import { overflowTextModifier } from '../../../utils';
import { formatContent } from '../helpers';
export const CellItem = (column, item, gridID, rowID, columnTypes, showDashIfEmpty) => {
    const isHeaderRow = rowID === -1;
    let typeClass = '';
    if (columnTypes && columnTypes[column]) {
        typeClass = `cell-type--${columnTypes[column].title}`;
    }
    const className = classNames('table_cell', `${gridID}-${column}`, typeClass);
    const displayItem = item.short ? overflowTextModifier(item.long, item.short) : item.long;
    const applyFormat = columnTypes && columnTypes[column] !== undefined && columnTypes[column].formatter !== undefined && columnTypes[column].fractionDigits !== undefined;
    let cellContent = isHeaderRow || !applyFormat ? displayItem : columnTypes && columnTypes[column] && formatContent(displayItem, columnTypes[column].formatter, columnTypes[column].fractionDigits);
    if (!isHeaderRow && showDashIfEmpty) {
        cellContent = cellContent || '—';
    }
    if (isHeaderRow) {
        return (React.createElement(Fragment, { key: uuid.v4() },
            React.createElement("th", { className: className },
                React.createElement("span", { className: "pos-rel" }, cellContent))));
    }
    else {
        return (React.createElement(Fragment, { key: uuid.v4() },
            React.createElement("td", { className: className },
                React.createElement("span", { className: "table_cell--item" }, cellContent))));
    }
};
//# sourceMappingURL=CellItem.js.map